import _forEach from 'lodash/forEach';

/* giving support for ttf only for now */
const fontFormatsToMimeType = {
    // otf: 'opentype',
    ttf: 'truetype',
    // woff: 'woff',
    // woff2: 'woff2',
};

export default (customFonts) => {
    const style = document.createElement('style');

    _forEach(customFonts, ({ fonts }) => _forEach(fonts, ({ unixName, fontData, format }) => {
        style.appendChild(document.createTextNode(`\
             @font-face {\
             font-family: ${unixName};\
             src: url(data:font/${fontFormatsToMimeType[format]};charset=utf-8;base64,${fontData}) format('${fontFormatsToMimeType[format]}');\
         }\
     `));
    }));

    document.head.appendChild(style);
};
